<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import { Quill } from 'vue-quill-editor'
import {
  blogComputed,
  authComputed,
  blogListMethod,
  categoryListMethod,
  categoryComputed,
  siteListMethod,
  courseListMethod,
  userListMethod,
  departmentListMethod,
  departmentComputed,
  collegeListMethod,
  collegeComputed,
} from '@state/helpers'
var Link = Quill.import('formats/link')
var builtInFunc = Link.sanitize
Link.sanitize = function customSanitizeLinkInput(linkValueInput) {
  var val = linkValueInput

  // do nothing, since this implies user's already using a custom protocol
  if (/^\w+:/.test(val));
  else if (!/^https?:/.test(val)) val = 'http://' + val

  return builtInFunc.call(this, val) // retain the built-in logic
}
export default {
  page: {
    title: 'Add Course',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      autocompleteItems: [
        {
          text: 'Artificial Intelligence',
        },
        {
          text: 'Python',
        },
        {
          text: 'Javascript',
        },
        {
          text: 'Big Data',
        },
        {
          text: 'HTML',
        },
      ],
      fields: [
        {
          key: 'title',
          label: 'Title',
          sortable: true,
          colType: 'default',
        },
        {
          key: 'category',
          label: 'Category',
          sortable: true,
          colType: 'default',
        },
        { key: 'action', title: 'Action', sortable: false, colType: 'button' },
      ],
      name: '',
      tag: '',
      tags: [],
      feature: '',
      features: [],
      topic: '',
      topics: [],
      careerOpportunity: '',
      careerProfile: '',
      careerProfiles: [],
      blogError: null,
      category: null,
      subcategory: null,
      blogDataStatus: false,
      isBlogError: false,
      isLoading: false,
      editorData: '',
      overview: '',
      // metaTitle: '',
      // metaDescription: '',
      categoryName: '',
      image: '',
      bgImage: '',
      show: false,
      siteconfiglist: [],
      platformId: 0,
      validTypeError: false,
      validSizeError: false,
      validTypeError1: false,
      validSizeError1: false,
      titleCharsLeft: '',
      platform: '',
      rating: null,
      careerSalary: '',
      collegelist: [],
      classlist: [],
      collegeId: null,
      collegeClass: [],
      departmentId: [],
      departmentlist: [],
      duration: '',
      ratingList: [
        { value: null, text: 'Add Rating', disabled: true },
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
      ],
    }
  },
  computed: {
    ...blogComputed,
    ...categoryComputed,
    ...authComputed,
    ...departmentComputed,
    ...collegeComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    const filter = {
      page: this.$route.query.page ? this.$route.query.page : 1,
      limit: 100,
      sort: 'date',
      order: '1',
    }
    this.fetchCategoryList({ filter })
    this.getDepartments()
    if (this.role === 'admin') {
      this.getListOfPlatform()
      this.getColleges()
    } else {
      this.platformId = this.profileData.platform_id
    }
    if (this.role === 'administrator') {
      this.getColleges()
    }
    if (this.role === 'college') {
      this.collegeId = this.profileData.college_id
      this.getDepartments()
    }
    if (this.role === 'hod') {
      this.collegeId = this.profileData.college_id
      this.departmentId.push(this.profileData.department)
      this.getClasses()
    }
    if (this.role === 'teacher') {
      this.collegeId = this.profileData.college_id
      this.collegeClass = this.profileData.collegeClass
      this.departmentId.push(this.profileData.department)
    }
  },
  methods: {
    ...blogListMethod,
    ...categoryListMethod,
    ...siteListMethod,
    ...courseListMethod,
    ...userListMethod,
    ...departmentListMethod,
    ...collegeListMethod,

    // get list of platform
    getListOfPlatform() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          // listitems.push({value:'All', text: 'All'})
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },
    // save blog method
    saveCourse() {
      if (
        localStorage.getItem('width') === '500' &&
        localStorage.getItem('height') === '500'
      ) {
        this.validSizeError = false
      } else {
        this.validSizeError = true
      }
      if (
        localStorage.getItem('widthBg') === '1000' &&
        localStorage.getItem('heightBg') === '500'
      ) {
        this.validSizeError1 = false
      } else {
        this.validSizeError1 = true
      }
      if (
        !this.validTypeError &&
        !this.validTypeError1 &&
        !this.validSizeError &&
        !this.validSizeError1
      ) {
        this.isLoading = true
        const Data = {
          name: this.name,
          description: this.editorData,
          overview: this.overview,
          // meta_title: this.metaTitle,
          // meta_description: this.metaDescription,
          category_id: this.category,
          subcategory_id: this.subcategory,
          image: this.image,
          bg_image: this.bgImage,
          career_salary: this.careerSalary,
          career_opportunity: this.careerOpportunity,
          career_profiles: this.careerProfiles,
          features: this.features,
          topics: this.topics,
          category: this.categoryName,
          status: false,
          platform_id: this.platformId,
          platform: this.platform,
          rating: this.rating,
          collegeClass: this.collegeClass,
          department: this.departmentId,
          college_id: this.collegeId,
          duration: this.duration + ' hours',
        }

        this.addCourse({ Data })
          .then((blog) => {
            this.isLoading = false
            this.$bvToast.toast('Course Added Successfully', {
              title: `Success`,
              toaster: 'b-toaster-top-right',
              solid: true,
              variant: 'success',
              appendToast: false,
            })
            this.$router.push({ name: 'course.list' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.blogError = getError.message
            this.isBlogError = true
            window.scrollTo(0, 0)
          })
      }
    },

    // trigger when select category
    selectCategory() {
      this.show = true
      this.categoryName = this.getCategoryName()
      this.fetchSubCategoryList({ category: this.category }).then((sub) => {
        this.show = false
      })
    },

    // it will return catgeory name
    getCategoryName() {
      var cate = this.categoryList.filter((item) => {
        return item._id === this.category
      })
      return cate[0].name
    },

    // trigger when select image in input
    uploadImage: function () {
      var file = document.getElementById('file').files[0]
      let mimeType = document.getElementById('file').files[0].type
      if (
        mimeType === 'image/png' ||
        mimeType === 'image/jpeg' ||
        mimeType === 'image/jpg'
      ) {
        this.validTypeError = false
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (evt) => {
          let img = new Image()
          img.onload = () => {
            localStorage.setItem('width', img.width)
            localStorage.setItem('height', img.height)
          }
          img.src = evt.target.result
          this.image = reader.result
        }
      } else {
        this.validTypeError = true
      }
    },

    uploadBgImage: function () {
      var file = document.getElementById('file1').files[0]
      let mimeType = document.getElementById('file1').files[0].type
      if (
        mimeType === 'image/png' ||
        mimeType === 'image/jpeg' ||
        mimeType === 'image/jpg'
      ) {
        this.validTypeError1 = false
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (evt) => {
          let img = new Image()
          img.onload = () => {
            localStorage.setItem('widthBg', img.width)
            localStorage.setItem('heightBg', img.height)
          }
          img.src = evt.target.result
          this.bgImage = reader.result
        }
      } else {
        this.validTypeError1 = true
      }
    },

    // filter tag
    filterTag(tags) {
      var finalTags = []
      tags.forEach((element) => {
        finalTags.push(element.text)
      })

      return finalTags
    },
    getCount() {
      this.titleCharsLeft = 100 - this.name.length
      if (this.name.length >= 100) {
        this.titleCharsLeft = 0
      }
    },
    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },
    restrictChars1(event) {
      if (event.charCode === 32 && !this.careerOpportunity.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          (event.charCode >= 48 && event.charCode <= 57) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },
    restrictChars2(event) {
      if (event.charCode === 32 && !this.overview.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          (event.charCode >= 48 && event.charCode <= 57) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },
    restrictChars3(event) {
      if (event.charCode === 32 && !this.duration.length) {
        event.preventDefault()
      } else {
        if (event.charCode >= 48 && event.charCode <= 57) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },
    getRating() {
      if (this.rating < 0 && this.rating > 5) {
        this.rating = 3
      }
    },
    tagValidator(tag) {
      if (tag.length > 30) {
      } else {
        // eslint-disable-next-line
        let format = /[!@#$%^*()_+\-=\[\]{};':"\\|,.<>\/?]+/
        if (format.test(tag)) {
        } else {
          return tag
        }
      }
    },

    getColleges() {
      this.collegeId = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select College',
            disabled: true,
          })
          college.docs.forEach((element) => {
            if (element.platform_id === this.platformId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },
    getClasses() {
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = []
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isBlogError"
              variant="danger"
              v-html="blogError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="saveCourse"
            >
              <b-form-group
                label="Name*(Max:100 characters)"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="name"
                  type="text"
                  parsley-trigger="change"
                  required
                  placeholder="Enter Name"
                  :maxlength="100"
                  @keyup="getCount"
                  @keypress="restrictChars($event)"
                ></b-form-input>
                <p v-if="titleCharsLeft !== ''"
                  >Characters left : {{ titleCharsLeft }}</p
                >
              </b-form-group>

              <b-form-group label="Category*" label-for="input-2">
                <b-form-select
                  v-model="category"
                  parsley-trigger="change"
                  required
                  @change="selectCategory"
                >
                  <b-select-option :value="null" disabled
                    >Select Category</b-select-option
                  >
                  <b-select-option
                    v-for="cate in categoryList"
                    :key="`cate${cate._id}`"
                    :value="cate._id"
                    >{{ cate.name }}</b-select-option
                  >
                </b-form-select>
              </b-form-group>
              <b-form-group label="Sub category" label-for="input-2">
                <b-form-select v-model="subcategory" parsley-trigger="change">
                  <b-select-option :value="null" disabled
                    >Select SubCategory</b-select-option
                  >
                  <b-select-option
                    v-for="cate in subCategoryList"
                    :key="`cate${cate._id}`"
                    :value="cate._id"
                    >{{ cate.name }}</b-select-option
                  >
                </b-form-select>
              </b-form-group>
              <b-form-group
                label="Career Opportunity*"
                label-for="input-1"
                title="Brief Description on career opportunites after learning this course"
              >
                <b-form-input
                  id="input-1"
                  v-model="careerOpportunity"
                  type="text"
                  parsley-trigger="change"
                  required
                  placeholder="Add Career Opportunity"
                  @keypress="restrictChars1($event)"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Career Profiles*" label-for="input-2">
                <b-form-tags
                  v-model="careerProfiles"
                  tag-pills
                  class="mb-2"
                  placeholder="Enter Profile and Press Enter..."
                  :tag-validator="tagValidator"
                ></b-form-tags>
              </b-form-group>

              <b-form-group label="Career Salary*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="careerSalary"
                  type="number"
                  parsley-trigger="change"
                  required
                  placeholder="Enter career salary"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Features*" label-for="input-2">
                <b-form-tags
                  v-model="features"
                  tag-pills
                  class="mb-2"
                  placeholder="Enter Features and Press Enter..."
                  :tag-validator="tagValidator"
                  invalid-tag-text="Invalid features text"
                ></b-form-tags>
              </b-form-group>
              <b-form-group label="Topics*" label-for="input-2">
                <b-form-tags
                  v-model="topics"
                  tag-pills
                  class="mb-2"
                  placeholder="Enter Topics and Press Enter..."
                  :tag-validator="tagValidator"
                  invalid-tag-text="Invalid topics text"
                ></b-form-tags>
              </b-form-group>
              <b-form-group label="Overview*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="overview"
                  type="text"
                  parsley-trigger="change"
                  required
                  placeholder="Enter Overview"
                  @keypress="restrictChars2($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Duration" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="duration"
                  type="text"
                  parsley-trigger="change"
                  required
                  placeholder="Enter Duration(in hours)"
                  @keypress="restrictChars3($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Select Rating*" label-for="input-1">
                <b-form-select
                  v-model="rating"
                  :options="ratingList"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Description*" label-for="input-2">
                <quill-editor v-model="editorData" output="html" />
              </b-form-group>

              <b-form-group label="Image*" label-for="input-2">
                <b-form-file
                  id="file"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  @change="uploadImage"
                ></b-form-file>
                <p v-if="validTypeError" class="showError"
                  >Not a valid file type</p
                >
                <p v-if="validSizeError" class="showError"
                  >Image Dimensions should be 500*500</p
                >
              </b-form-group>
              <b-form-group
                label="Course Background Image*"
                label-for="input-2"
              >
                <b-form-file
                  id="file1"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  @change="uploadBgImage"
                ></b-form-file>
                <p v-if="validTypeError1" class="showError"
                  >Not a valid file type</p
                >
                <p v-if="validSizeError1" class="showError"
                  >Image Dimensions should be 1000*500</p
                >
              </b-form-group>
              <b-form-group
                v-if="role === 'admin'"
                label="Select Platform*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="platformId"
                  :options="siteconfiglist"
                  @change="getColleges"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                v-if="role === 'administrator' || role === 'admin'"
                label="Select College*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="collegeId"
                  :options="collegelist"
                  @change="getDepartments"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                v-if="role !== 'hod' && role !== 'teacher'"
                label="Select Department*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="departmentId"
                  :options="departmentlist"
                  multiple
                  @change="getClasses"
                ></b-form-select>
              </b-form-group>

              <b-form-group
                v-if="role !== 'teacher'"
                label="Select Class*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="collegeClass"
                  :options="classlist"
                  multiple
                ></b-form-select>
              </b-form-group>
              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/course-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.vue-tags-input {
  max-width: 100% !important;
}
.showError {
  color: red;
}
.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  /* font-family: inherit; */
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
